import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatetimeDisplay from '../../../../components/date-time-display';

class ModifiedLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { value, historical } = this.props;

    const isDeleted = value.is_deleted === true;
    
    const date = isDeleted ? value.deleted_at : value.updated_at;
    const name = value.updated_by;
    let action = historical ? 'Update' : 'Last updated';
    if (isDeleted) {
      action = 'Deleted';
    }


    if (!date) {
      return null;
    }

    return (
      <em className={isDeleted ? 'text-danger' : ''}>
        {action} on <strong><DatetimeDisplay value={date} format="shortWithTime" /></strong> {name !== null && name !== undefined && name.length > 0 && <span>&nbsp;by <strong>{name}</strong></span>}
      </em>
    );
  }
}

ModifiedLog.propTypes = {
  value: PropTypes.shape({
    updated_at: PropTypes.string,
    updated_by: PropTypes.string,
  }).isRequired,
  historical: PropTypes.bool,
};
ModifiedLog.defaultProps = {
  historical: false,
};
export default ModifiedLog;
